// RecMassageAestheticMedicine.jsx - Professional Spa & Wellness Guide
import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../contexts/I18n";
import "./recommended.css";

const recommendedItems = [
  { title: "hairTrendsStylingGuide", image: "images/hair.jpg", slug: "hair-&-nail-salon" },
  { title: "mensGroomingMustacheStyles", image: "images/barbershop.jpg", slug: "barbershop" },
  { title: "tattooIdeasArtistGuide", image: "images/tattoo.jpg", slug: "tattoo-&-piercing-shops" },
  { title: "hairRemovalSkincare", image: "images/hair1.jpg", slug: "hair-removal" },
  { title: "browLashEnhancement", image: "images/brows.jpg", slug: "makeup-&-brows-&-lashes" },
  { title: "spaWellnessTreatments", image: "images/massage.jpg", slug: "massage-&-aesthetic-medicine" },
];

export default function RecMassageAestheticMedicine() {
  const { t, lang } = useI18n();
  
  const handleTocClick = (e, targetId) => {
    e.preventDefault();
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
  
  return (
    <div className="rec-page" dir={lang === 'ar' ? 'rtl' : 'ltr'}>
      <details className="rec-mobile-panel" role="navigation" aria-label="Recommended quick links">
        <summary>
          {t('recommendedServices')}
                    <span className="rec-plus" aria-hidden="true">+</span>

          <span className="rec-plus" aria-hidden="true"></span>
        </summary>
        <ul className="rec-quick-list">
          {recommendedItems.map((it) => (
            <li key={it.slug}>
              <Link to={`/rec/${it.slug}`}>{t(it.title)}</Link>
            </li>
          ))}
        </ul>
      </details>

      <aside className="rec-left" aria-label="Recommended Services">
        <h2 className="rec-left__title">{t('recommendedServices')}</h2>
        <ul className="rec-left__list">
          {recommendedItems.map((it) => (
            <li key={it.slug} className="rec-left__item">
              <Link to={`/rec/${it.slug}`} className="rec-left__link">
                <img className="rec-left__thumb" src={`/${it.image}`} alt="" />
                <span className="rec-left__label">{t(it.title)}</span>
              </Link>
            </li>
          ))}
        </ul>
      </aside>

      <article className="rec-article">
        <header className="rec-hero">
          <h1>{t('completeSpaWellnessGuide')}</h1>
          <p className="rec-meta">{t('professionalWellnessGuide')}</p>
          <p className="rec-dek">
            {t('recSpaIntro')}
          </p>
          <div className="rec-cta-row">
            <Link className="btn primary" to="/service/massage-&-aesthetic-medicine">{t('bookSpaTreatment')}</Link>
            <Link className="btn outline" to="/service/massage-&-aesthetic-medicine">{t('viewAllServices')}</Link>
          </div>
        </header>

        <nav className="rec-toc" aria-label="Table of Contents">
          <h2>{t('tableOfContents')}</h2>
          <div className="rec-toc-summary">
            <p><strong>4 {t('sections')}</strong> • <strong>50 {t('minTotalRead')}</strong></p>
          </div>
          <ul className="rec-toc-list">
            <li className="rec-toc-item">
              <a href="#massage-therapy" className="rec-toc-link" onClick={(e) => handleTocClick(e, 'massage-therapy')}>
                <div className="rec-toc-content">
                  <h3 className="rec-toc-title">{t('professionalMassageTherapy')}</h3>
                  <p className="rec-toc-description">{t('discoverTherapeuticMassageTypes')}</p>
                  <div className="rec-toc-meta">
                    <span className="rec-toc-time">14 {t('minRead')}</span>
                    <span className="rec-toc-difficulty rec-toc-difficulty--beginner">{t('beginner')}</span>
                  </div>
                </div>
              </a>
            </li>
            <li className="rec-toc-item">
              <a href="#aesthetic-treatments" className="rec-toc-link" onClick={(e) => handleTocClick(e, 'aesthetic-treatments')}>
                <div className="rec-toc-content">
                  <h3 className="rec-toc-title">{t('advancedAestheticMedicine')}</h3>
                  <p className="rec-toc-description">{t('exploreCuttingEdgeAesthetic')}</p>
                  <div className="rec-toc-meta">
                    <span className="rec-toc-time">16 {t('minRead')}</span>
                    <span className="rec-toc-difficulty rec-toc-difficulty--advanced">{t('advanced')}</span>
                  </div>
                </div>
              </a>
            </li>
            <li className="rec-toc-item">
              <a href="#wellness-therapies" className="rec-toc-link" onClick={(e) => handleTocClick(e, 'wellness-therapies')}>
                <div className="rec-toc-content">
                  <h3 className="rec-toc-title">{t('holisticWellnessTherapies')}</h3>
                  <p className="rec-toc-description">{t('discoverHolisticTreatmentModalities')}</p>
                  <div className="rec-toc-meta">
                    <span className="rec-toc-time">12 {t('minRead')}</span>
                    <span className="rec-toc-difficulty rec-toc-difficulty--intermediate">{t('intermediate')}</span>
                  </div>
                </div>
              </a>
            </li>
            <li className="rec-toc-item">
              <a href="#spa-experience" className="rec-toc-link" onClick={(e) => handleTocClick(e, 'spa-experience')}>
                <div className="rec-toc-content">
                  <h3 className="rec-toc-title">{t('completeSpaExperience')}</h3>
                  <p className="rec-toc-description">{t('learnMaximizeSpaExperience')}</p>
                  <div className="rec-toc-meta">
                    <span className="rec-toc-time">8 {t('minRead')}</span>
                    <span className="rec-toc-difficulty rec-toc-difficulty--beginner">{t('beginner')}</span>
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </nav>

        <section id="massage-therapy" className="rec-section">
          <div className="rec-section-header">
            <div className="rec-section-info">
              <h3>{t('professionalMassageTherapy')}</h3>
              <div className="rec-section-details">
                <span className="rec-section-time">14 {t('minRead')}</span>
                <span className="rec-section-difficulty rec-section-difficulty--beginner">{t('beginner')}</span>
              </div>
            </div>
          </div>
          <div className="rec-section-intro">
            <p>{t('recMassageIntro')}</p>
          </div>
          <div className="rec-quick-tips">
            <h4>{t('quickTips')}</h4>
            <ul className="rec-tips-list">
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recMassageQuickTip1')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recMassageQuickTip2')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recMassageQuickTip3')}</span><span className="rec-tip-icon">💡</span></li>
            </ul>
          </div>
          <div className="rec-section-body">
            <div className="rec-section-content">
              <div>
              <p>{t('recMassageContent1')}</p>
              
              <h4>{t('recMassageContent2')}</h4>
              
              <h5>{t('recMassageContent3')}</h5>
              <p>
                <strong>{t('recMassageContent4')}</strong> {t('recMassageContent5')}
              </p>
              <p>
                <strong>{t('recMassageContent6')}</strong> {t('recMassageContent7')}
              </p>
              <p>
                <strong>{t('recMassageContent8')}</strong> {t('recMassageContent9')}
              </p>
              <p>
                <strong>{t('recMassageContent10')}</strong> {t('recMassageContent11')}
              </p>
              
              <h5>{t('recMassageContent12')}</h5>
              <p>
                <strong>{t('recMassageContent4')}</strong> {t('recMassageContent13')}
              </p>
              <p>
                <strong>{t('recMassageContent6')}</strong> {t('recMassageContent14')}
              </p>
              <p>
                <strong>{t('recMassageContent8')}</strong> {t('recMassageContent15')}
              </p>
              <p>
                <strong>{t('recMassageContent10')}</strong> {t('recMassageContent11')}
              </p>
              
              <h5>{t('recMassageContent16')}</h5>
              <p>
                <strong>{t('recMassageContent4')}</strong> {t('recMassageContent17')}
              </p>
              <p>
                <strong>{t('recMassageContent6')}</strong> {t('recMassageContent18')}
              </p>
              <p>
                <strong>{t('recMassageContent8')}</strong> {t('recMassageContent19')}
              </p>
              <p>
                <strong>{t('recMassageContent10')}</strong> {t('recMassageContent20')}
              </p>
              
              <h5>{t('recMassageContent21')}</h5>
              <p>
                <strong>{t('recMassageContent4')}</strong> {t('recMassageContent22')}
              </p>
              <p>
                <strong>{t('recMassageContent6')}</strong> {t('recMassageContent23')}
              </p>
              <p>
                <strong>{t('recMassageContent8')}</strong> {t('recMassageContent24')}
              </p>
              <p>
                <strong>{t('recMassageContent10')}</strong> {t('recMassageContent11')}
              </p>
              
              <h4>{t('recMassageContent25')}</h4>
              
              <h5>{t('recMassageContent26')}</h5>
              <p>
                <strong>{t('recMassageContent4')}</strong> {t('recMassageContent27')}
              </p>
              <p>
                <strong>{t('recMassageContent6')}</strong> {t('recMassageContent28')}
              </p>
              <p>
                <strong>{t('recMassageContent8')}</strong> {t('recMassageContent29')}
              </p>
              
              <h5>{t('recMassageContent30')}</h5>
              <p>
                <strong>{t('recMassageContent4')}</strong> {t('recMassageContent31')}
              </p>
              <p>
                <strong>{t('recMassageContent6')}</strong> {t('recMassageContent32')}
              </p>
              <p>
                <strong>{t('recMassageContent8')}</strong> {t('recMassageContent33')}
              </p>
              
              <h4>{t('recMassageContent34')}</h4>
              
              <h5>{t('recMassageContent35')}</h5>
              <ul>
                <li><strong>{t('recMassageContent36')}</strong> {t('recMassageContent37')}</li>
                <li><strong>{t('recMassageContent38')}</strong> {t('recMassageContent39')}</li>
                <li><strong>{t('recMassageContent40')}</strong> {t('recMassageContent41')}</li>
                <li><strong>{t('recMassageContent42')}</strong> {t('recMassageContent43')}</li>
                <li><strong>{t('recMassageContent44')}</strong> {t('recMassageContent45')}</li>
              </ul>
              
              <h5>{t('recMassageContent46')}</h5>
              <ul>
                <li><strong>{t('recMassageContent47')}</strong> {t('recMassageContent48')}</li>
                <li><strong>{t('recMassageContent49')}</strong> {t('recMassageContent50')}</li>
                <li><strong>{t('recMassageContent51')}</strong> {t('recMassageContent52')}</li>
                <li><strong>{t('recMassageContent53')}</strong> {t('recMassageContent54')}</li>
                <li><strong>{t('recMassageContent55')}</strong> {t('recMassageContent56')}</li>
              </ul>
              </div>
            </div>
          </div>
        </section>

        <section id="aesthetic-treatments" className="rec-section">
          <div className="rec-section-header">
            <div className="rec-section-info">
              <h3>{t('advancedAestheticMedicine')}</h3>
              <div className="rec-section-details">
                <span className="rec-section-time">16 {t('minRead')}</span>
                <span className="rec-section-difficulty rec-section-difficulty--advanced">{t('advanced')}</span>
              </div>
            </div>
          </div>
          <div className="rec-section-intro">
            <p>{t('recAestheticIntro')}</p>
          </div>
          <div className="rec-quick-tips">
            <h4>{t('quickTips')}</h4>
            <ul className="rec-tips-list">
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recAestheticQuickTip1')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recAestheticQuickTip2')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recAestheticQuickTip3')}</span><span className="rec-tip-icon">💡</span></li>
            </ul>
          </div>
          <div className="rec-section-body">
            <div className="rec-section-content">
              <div>
              <p>{t('recAestheticContent1')}</p>
              
              <h4>{t('recAestheticContent2')}</h4>
              
              <h5>{t('recAestheticContent3')}</h5>
              <p>
                <strong>{t('recMassageContent4')}</strong> {t('recAestheticContent4')}
              </p>
              <p>
                <strong>{t('recMassageContent6')}</strong> {t('recAestheticContent5')}
              </p>
              <p>
                <strong>{t('recAestheticContent6')}</strong> {t('recAestheticContent7')}
              </p>
              <p>
                <strong>{t('recMassageContent10')}</strong> {t('recAestheticContent8')}
              </p>
              
              <h5>{t('recAestheticContent9')}</h5>
              <p>
                <strong>{t('recMassageContent4')}</strong> {t('recAestheticContent10')}
              </p>
              <p>
                <strong>{t('recMassageContent6')}</strong> {t('recAestheticContent11')}
              </p>
              <p>
                <strong>{t('recAestheticContent6')}</strong> {t('recAestheticContent12')}
              </p>
              <p>
                <strong>{t('recMassageContent10')}</strong> {t('recAestheticContent13')}
              </p>
              
              <h5>{t('recAestheticContent14')}</h5>
              <p>
                <strong>{t('recMassageContent4')}</strong> {t('recAestheticContent15')}
              </p>
              <p>
                <strong>{t('recMassageContent6')}</strong> {t('recAestheticContent16')}
              </p>
              <p>
                <strong>{t('recAestheticContent17')}</strong> {t('recAestheticContent18')}
              </p>
              <p>
                <strong>{t('recAestheticContent19')}</strong> {t('recAestheticContent20')}
              </p>
              
              <h5>{t('recAestheticContent21')}</h5>
              <p>
                <strong>{t('recMassageContent4')}</strong> {t('recAestheticContent22')}
              </p>
              <p>
                <strong>{t('recMassageContent6')}</strong> {t('recAestheticContent23')}
              </p>
              <p>
                <strong>{t('recAestheticContent17')}</strong> {t('recAestheticContent24')}
              </p>
              <p>
                <strong>{t('recAestheticContent25')}</strong> {t('recAestheticContent26')}
              </p>
              
              <h4>{t('recAestheticContent27')}</h4>
              
              <h5>{t('recAestheticContent28')}</h5>
              <p>
                <strong>{t('recMassageContent4')}</strong> {t('recAestheticContent29')}
              </p>
              <p>
                <strong>{t('recMassageContent6')}</strong> {t('recAestheticContent30')}
              </p>
              <p>
                <strong>{t('recAestheticContent19')}</strong> {t('recAestheticContent31')}
              </p>
              
              <h5>{t('recAestheticContent32')}</h5>
              <p>
                <strong>{t('recMassageContent4')}</strong> {t('recAestheticContent33')}
              </p>
              <p>
                <strong>{t('recMassageContent6')}</strong> {t('recAestheticContent34')}
              </p>
              <p>
                <strong>{t('recAestheticContent19')}</strong> {t('recAestheticContent35')}
              </p>
              
              <h5>{t('recAestheticContent36')}</h5>
              <p>
                <strong>{t('recMassageContent4')}</strong> {t('recAestheticContent37')}
              </p>
              <p>
                <strong>{t('recMassageContent6')}</strong> {t('recAestheticContent38')}
              </p>
              <p>
                <strong>{t('recAestheticContent19')}</strong> {t('recAestheticContent39')}
              </p>
              
              <h4>{t('recAestheticContent40')}</h4>
              
              <h5>{t('recAestheticContent41')}</h5>
              <ul>
                <li><strong>{t('recAestheticContent42')}</strong> {t('recAestheticContent43')}</li>
                <li><strong>{t('recAestheticContent44')}</strong> {t('recAestheticContent45')}</li>
                <li><strong>{t('recAestheticContent46')}</strong> {t('recAestheticContent47')}</li>
                <li><strong>{t('recAestheticContent48')}</strong> {t('recAestheticContent49')}</li>
              </ul>
              
              <h5>{t('recAestheticContent50')}</h5>
              <ul>
                <li><strong>{t('recAestheticContent51')}</strong> {t('recAestheticContent52')}</li>
                <li><strong>{t('recAestheticContent53')}</strong> {t('recAestheticContent54')}</li>
                <li><strong>{t('recAestheticContent55')}</strong> {t('recAestheticContent56')}</li>
                <li><strong>{t('recAestheticContent57')}</strong> {t('recAestheticContent58')}</li>
              </ul>
              </div>
            </div>
          </div>
        </section>

        <section id="wellness-therapies" className="rec-section">
          <div className="rec-section-header">
            <div className="rec-section-info">
              <h3>{t('holisticWellnessTherapies')}</h3>
              <div className="rec-section-details">
                <span className="rec-section-time">12 {t('minRead')}</span>
                <span className="rec-section-difficulty rec-section-difficulty--intermediate">{t('intermediate')}</span>
              </div>
            </div>
          </div>
          <div className="rec-section-intro">
            <p>{t('recWellnessIntro')}</p>
          </div>
          <div className="rec-quick-tips">
            <h4>{t('quickTips')}</h4>
            <ul className="rec-tips-list">
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recWellnessQuickTip1')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recWellnessQuickTip2')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recWellnessQuickTip3')}</span><span className="rec-tip-icon">💡</span></li>
            </ul>
          </div>
          <div className="rec-section-body">
            <div className="rec-section-content">
              <div>
              <p>{t('recWellnessContent1')}</p>
              
              <h4>{t('recWellnessContent2')}</h4>
              
              <h5>{t('recWellnessContent3')}</h5>
              <p>
                <strong>{t('recMassageContent4')}</strong> {t('recWellnessContent4')}
              </p>
              <p>
                <strong>{t('recMassageContent6')}</strong> {t('recWellnessContent5')}
              </p>
              <p>
                <strong>{t('recWellnessContent6')}</strong> {t('recWellnessContent7')}
              </p>
              <p>
                <strong>{t('recWellnessContent8')}</strong> {t('recWellnessContent9')}
              </p>
              
              <h5>{t('recWellnessContent10')}</h5>
              <p>
                <strong>{t('recMassageContent4')}</strong> {t('recWellnessContent11')}
              </p>
              <p>
                <strong>{t('recMassageContent6')}</strong> {t('recWellnessContent12')}
              </p>
              <p>
                <strong>{t('recWellnessContent13')}</strong> {t('recWellnessContent14')}
              </p>
              <p>
                <strong>{t('recMassageContent10')}</strong> {t('recWellnessContent15')}
              </p>
              
              <h5>{t('recWellnessContent16')}</h5>
              <p>
                <strong>{t('recMassageContent4')}</strong> {t('recWellnessContent17')}
              </p>
              <p>
                <strong>{t('recMassageContent6')}</strong> {t('recWellnessContent18')}
              </p>
              <p>
                <strong>{t('recWellnessContent13')}</strong> {t('recWellnessContent19')}
              </p>
              <p>
                <strong>{t('recWellnessContent20')}</strong> {t('recWellnessContent21')}
              </p>
              
              <h5>{t('recWellnessContent22')}</h5>
              <p>
                <strong>{t('recMassageContent4')}</strong> {t('recWellnessContent23')}
              </p>
              <p>
                <strong>{t('recMassageContent6')}</strong> {t('recWellnessContent24')}
              </p>
              <p>
                <strong>{t('recWellnessContent25')}</strong> {t('recWellnessContent26')}
              </p>
              <p>
                <strong>{t('recMassageContent10')}</strong> {t('recWellnessContent27')}
              </p>
              
              <h4>{t('recWellnessContent28')}</h4>
              
              <h5>{t('recWellnessContent29')}</h5>
              <p>
                <strong>{t('recMassageContent4')}</strong> {t('recWellnessContent30')}
              </p>
              <p>
                <strong>{t('recMassageContent6')}</strong> {t('recWellnessContent31')}
              </p>
              <p>
                <strong>{t('recMassageContent8')}</strong> {t('recWellnessContent32')}
              </p>
              
              <h5>{t('recWellnessContent33')}</h5>
              <p>
                <strong>{t('recMassageContent4')}</strong> {t('recWellnessContent34')}
              </p>
              <p>
                <strong>{t('recMassageContent6')}</strong> {t('recWellnessContent35')}
              </p>
              <p>
                <strong>{t('recMassageContent8')}</strong> {t('recWellnessContent36')}
              </p>
              
              <h4>{t('recWellnessContent37')}</h4>
              
              <h5>{t('recWellnessContent38')}</h5>
              <ul>
                <li><strong>{t('recWellnessContent39')}</strong> {t('recWellnessContent40')}</li>
                <li><strong>{t('recWellnessContent41')}</strong> {t('recWellnessContent42')}</li>
                <li><strong>{t('recWellnessContent43')}</strong> {t('recWellnessContent44')}</li>
                <li><strong>{t('recWellnessContent45')}</strong> {t('recWellnessContent46')}</li>
                <li><strong>{t('recWellnessContent47')}</strong> {t('recWellnessContent48')}</li>
              </ul>
              
              <h5>{t('recWellnessContent49')}</h5>
              <ul>
                <li><strong>{t('recWellnessContent50')}</strong> {t('recWellnessContent51')}</li>
                <li><strong>{t('recWellnessContent52')}</strong> {t('recWellnessContent53')}</li>
                <li><strong>{t('recWellnessContent54')}</strong> {t('recWellnessContent55')}</li>
                <li><strong>{t('recWellnessContent56')}</strong> {t('recWellnessContent57')}</li>
                <li><strong>{t('recWellnessContent58')}</strong> {t('recWellnessContent59')}</li>
              </ul>
              </div>
            </div>
          </div>
        </section>

        <section id="spa-experience" className="rec-section">
          <div className="rec-section-header">
            <div className="rec-section-info">
              <h3>{t('completeSpaExperience')}</h3>
              <div className="rec-section-details">
                <span className="rec-section-time">8 {t('minRead')}</span>
                <span className="rec-section-difficulty rec-section-difficulty--beginner">{t('beginner')}</span>
              </div>
            </div>
          </div>
          <div className="rec-section-intro">
            <p>{t('recSpaExperienceIntro')}</p>
          </div>
          <div className="rec-quick-tips">
            <h4>{t('quickTips')}</h4>
            <ul className="rec-tips-list">
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recSpaExperienceQuickTip1')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recSpaExperienceQuickTip2')}</span><span className="rec-tip-icon">💡</span></li>
              <li className="rec-tip-item"><span className="rec-tip-text">{t('recSpaExperienceQuickTip3')}</span><span className="rec-tip-icon">💡</span></li>
            </ul>
          </div>
          <div className="rec-section-body">
            <div className="rec-section-content">
              <div>
              <p>{t('recSpaExperienceContent1')}</p>
              
              <h4>{t('recSpaExperienceContent2')}</h4>
              
              <h5>{t('recSpaExperienceContent3')}</h5>
              <ul>
                <li><strong>{t('recSpaExperienceContent4')}</strong> {t('recSpaExperienceContent5')}</li>
                <li><strong>{t('recSpaExperienceContent6')}</strong> {t('recSpaExperienceContent7')}</li>
                <li><strong>{t('recSpaExperienceContent8')}</strong> {t('recSpaExperienceContent9')}</li>
                <li><strong>{t('recSpaExperienceContent10')}</strong> {t('recSpaExperienceContent11')}</li>
                <li><strong>{t('recSpaExperienceContent12')}</strong> {t('recSpaExperienceContent13')}</li>
              </ul>
              
              <h5>{t('recSpaExperienceContent14')}</h5>
              <ul>
                <li><strong>{t('recSpaExperienceContent15')}</strong> {t('recSpaExperienceContent16')}</li>
                <li><strong>{t('recSpaExperienceContent17')}</strong> {t('recSpaExperienceContent18')}</li>
                <li><strong>{t('recSpaExperienceContent19')}</strong> {t('recSpaExperienceContent20')}</li>
                <li><strong>{t('recSpaExperienceContent21')}</strong> {t('recSpaExperienceContent22')}</li>
              </ul>
              
              <h4>{t('recSpaExperienceContent23')}</h4>
              
              <h5>{t('recSpaExperienceContent24')}</h5>
              <ul>
                <li><strong>{t('recSpaExperienceContent25')}</strong> {t('recSpaExperienceContent26')}</li>
                <li><strong>{t('recSpaExperienceContent27')}</strong> {t('recSpaExperienceContent28')}</li>
                <li><strong>{t('recSpaExperienceContent29')}</strong> {t('recSpaExperienceContent30')}</li>
                <li><strong>{t('recSpaExperienceContent31')}</strong> {t('recSpaExperienceContent32')}</li>
              </ul>
              
              <h5>{t('recSpaExperienceContent33')}</h5>
              <ul>
                <li><strong>{t('recSpaExperienceContent34')}</strong> {t('recSpaExperienceContent35')}</li>
                <li><strong>{t('recSpaExperienceContent36')}</strong> {t('recSpaExperienceContent37')}</li>
                <li><strong>{t('recSpaExperienceContent38')}</strong> {t('recSpaExperienceContent39')}</li>
                <li><strong>{t('recSpaExperienceContent40')}</strong> {t('recSpaExperienceContent41')}</li>
              </ul>
              
              <h4>{t('recSpaExperienceContent42')}</h4>
              
              <h5>{t('recSpaExperienceContent43')}</h5>
              <ul>
                <li><strong>{t('recSpaExperienceContent4')}</strong> {t('recSpaExperienceContent44')}</li>
                <li><strong>{t('recSpaExperienceContent45')}</strong> {t('recSpaExperienceContent46')}</li>
                <li><strong>{t('recSpaExperienceContent47')}</strong> {t('recSpaExperienceContent48')}</li>
                <li><strong>{t('recSpaExperienceContent49')}</strong> {t('recSpaExperienceContent50')}</li>
              </ul>
              
              <h5>{t('recSpaExperienceContent51')}</h5>
              <ul>
                <li><strong>{t('recSpaExperienceContent52')}</strong> {t('recSpaExperienceContent53')}</li>
                <li><strong>{t('recSpaExperienceContent54')}</strong> {t('recSpaExperienceContent55')}</li>
                <li><strong>{t('recSpaExperienceContent56')}</strong> {t('recSpaExperienceContent57')}</li>
                <li><strong>{t('recSpaExperienceContent58')}</strong> {t('recSpaExperienceContent59')}</li>
              </ul>
              
              <h4>{t('recSpaExperienceContent60')}</h4>
              
              <h5>{t('recSpaExperienceContent61')}</h5>
              <ul>
                <li><strong>{t('recSpaExperienceContent62')}</strong> {t('recSpaExperienceContent63')}</li>
                <li><strong>{t('recSpaExperienceContent64')}</strong> {t('recSpaExperienceContent65')}</li>
                <li><strong>{t('recSpaExperienceContent66')}</strong> {t('recSpaExperienceContent67')}</li>
                <li><strong>{t('recSpaExperienceContent68')}</strong> {t('recSpaExperienceContent69')}</li>
                <li><strong>{t('recSpaExperienceContent70')}</strong> {t('recSpaExperienceContent71')}</li>
              </ul>
              
              <h5>{t('recSpaExperienceContent72')}</h5>
              <ul>
                <li><strong>{t('recSpaExperienceContent73')}</strong> {t('recSpaExperienceContent74')}</li>
                <li><strong>{t('recSpaExperienceContent75')}</strong> {t('recSpaExperienceContent76')}</li>
                <li><strong>{t('recSpaExperienceContent77')}</strong> {t('recSpaExperienceContent78')}</li>
                <li><strong>{t('recSpaExperienceContent79')}</strong> {t('recSpaExperienceContent80')}</li>
                <li><strong>{t('recSpaExperienceContent81')}</strong> {t('recSpaExperienceContent82')}</li>
              </ul>
              </div>
            </div>
          </div>
        </section>

        <footer className="rec-footer">
          <h3>{t('readyBeginWellnessJourney')}</h3>
          <p>
            {t('dontWaitExperienceSpa')}
          </p>
          <div className="rec-cta-row">
            <Link className="btn primary" to="/service/massage-&-aesthetic-medicine">{t('bookSpaTreatment')}</Link>
            <Link className="btn outline" to="/service/massage-&-aesthetic-medicine">{t('bookMassage')}</Link>
          </div>
        </footer>
      </article>
    </div>
  );
}